import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMoreVertical = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 7,
			y: 3,
			width: 2,
			height: 2,
			fill: "currentColor",
			fillOpacity: .4
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 7,
			y: 7,
			width: 2,
			height: 2,
			fill: "currentColor",
			fillOpacity: .4
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 7,
			y: 11,
			width: 2,
			height: 2,
			fill: "currentColor",
			fillOpacity: .4
		})
	]
});
export { SvgMoreVertical as ReactComponent };
